class LocationPanel extends Panel {
  websites = {
    GB: {
      name: 'United Kingdom',
      url: 'www.jessicamccormack.com',
    },
    US: {
      name: 'United States',
      url: 'us.jessicamccormack.com',
    },
  };

  getCurrentWebsiteCode() {
    const hostname = new URL(this.dataset.currentUrl).hostname;

    for (const key in this.websites) {
      if (this.websites[key].url === hostname) {
        return key;
      }
    }

    return null;
  }

  connectedCallback() {
    this.countriesData = window.countriesData;
    this.fillDropdown();

    this.querySelector('#localization_form').addEventListener('submit', (ev) => {
      let countryCode = this.querySelector('#localization_form [name="country_code"]')?.value;
      let currentSite = this.getCurrentWebsiteCode();
      let targetSite = this.countriesData[countryCode].website;

      let expireDate = new Date();
      let currentTime = expireDate.getTime();
      expireDate.setTime(currentTime + 1000 * 60 * 60 * 24 * 30);
      this.setCookie('current_country', countryCode, { expires: expireDate });

      if (currentSite !== targetSite) {
        ev.preventDefault();
        window.location = `https://` + this.websites[targetSite].url;
      }
    });

    // don't geolocate as setting disabled or the user on unsupported domain
    if (!this.dataset.enableGeodetection || !window.location.host.includes('mccormack.com')) {
      return;
    }

    const pickedCountryCode = this.getCookie('current_country');
    if (pickedCountryCode) {
      if (this.countriesData[pickedCountryCode]?.website !== this.getCurrentWebsiteCode()) {
        // the user has a cookie but is on the wrong website
        this.markCountryAsSelected(pickedCountryCode);
        document.querySelector('[data-panel-transition="OPEN_LOCATION"]').click();
      }
      return;
    }

    // geolocate the user
    this.initGeoDetection();
  }

  fillDropdown() {
    let select = this.querySelector('[name="country_code"]');
    Object.keys(this.countriesData).forEach((country) => {
      select.insertAdjacentHTML(
        'beforeend',
        `<option value="${country}" ${this.dataset.currentLocale === country ? 'selected="selected"' : ''}>${this.countriesData[country].name}</option>`,
      );
    });
  }

  markCountryAsSelected(country) {
    let select = this.querySelector('[name="country_code"]');
    if ([...select.options].some((option) => option.value === country)) {
      select.value = country;
    }
  }

  async initGeoDetection() {
    let result = await fetch(window.routes.root + 'browsing_context_suggestions.json' + '?country[enabled]=true').then(
      (r) => r.json(),
    );

    let urlParams = new URLSearchParams(window.location.search);

    this.geolocationCountryCode = urlParams.get('country') || result.detected_values.country.handle;

    if (
      !this.countryGeolocation.website ||
      this.websites[this.countryGeolocation.website].url !== window.location.hostname
    ) {
      this.markCountryAsSelected(this.geolocationCountryCode);
      document.querySelector('[data-panel-transition="OPEN_LOCATION"]').click();
    }
  }

  get countryGeolocation() {
    return this.countriesData[this.geolocationCountryCode];
  }

  transitionFrom(previousState, newState, triggerElement, previousPanel) {
    //super.transitionFrom(previousState, newState, triggerElement, previousPanel);
    this.activate();
    requestAnimationFrame(() => {
      if (previousState === 'idle') {
        actions.openRightBottomNav().then(() => {
          window.trapFocus(this, this.defaultFocus, triggerElement);
        });
      }
    });
  }

  setCookie(name, value, passedOptions = {}) {
    let defaultOptions = {
      path: '/',
      value: '1',
      domain: '.jessicamccormack.com',
    };

    let options = { ...defaultOptions, ...passedOptions };

    if (options.expires instanceof Date) {
      options.expires = options.expires.toUTCString();
    }

    let updatedCookie = encodeURIComponent(name) + '=' + encodeURIComponent(value);

    for (let optionKey in options) {
      updatedCookie += '; ' + optionKey;
      let optionValue = options[optionKey];
      if (optionValue !== true) {
        updatedCookie += '=' + optionValue;
      }
    }

    document.cookie = updatedCookie;
  }

  getCookie(name) {
    let matches = document.cookie.match(
      new RegExp('(?:^|; )' + name.replace(/([.$?*|{}()[]\\\/+^])/g, '\\$1') + '=([^;]*)'),
    );
    return matches ? decodeURIComponent(matches[1]) : undefined;
  }
}
customElements.define('location-panel', LocationPanel);
